const BadgeCount = ({ count }) => {
    if (!count || count <= 0) return null;

    return (
        <div style={styles.badge}>
            {count}
        </div>
    );
};

const styles = {
    badge: {
        backgroundColor: 'red',
        color: 'white',
        borderRadius: '999px',
        padding: '2px 6px',
        fontSize: '12px',
        fontWeight: 'bold',
        minWidth: '20px',
        textAlign: 'center',
        display: 'inline-block',
    }
};

export default BadgeCount;
